import './index.scss';
import React, { useState, useEffect, useRef, useContext } from 'react';
import _ from 'lodash';
import { any, bool, func, number, object } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import loadable from '@loadable/component';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SendContact from './SendContact.jsx';
import Image from '../../common/Image.jsx';
import {
  setCouponData,
  getSavedCoupons,
  setSavedLinkClick
} from '../../../actions/userDrug';
import { modalActions } from '../../../reducers/modalSlice';
import {
  addToWallet,
  fetchCouponData
} from '../../../services/Api/Coupon/CouponService';
import {
  deletePharmacyCoupon,
  saveCoupon
} from '../../../services/Api/SaveCoupon/SaveCouponService';
import {
  INTELLIMIZE_COUPON_EVENT,
  LOYALTY_SIGNUP_MODAL,
  HIDE_LOYALTY_MODAL_PHARMA_LIST,
  WALMART_PBA_CLIENT_NAME,
  INTELLIMIZE_LOYALTY_SIGN_UP_STARTED
} from '../../../constants/defaults';
import DialogCloseButton from '../../common/Dialog/DialogCloseButton';
import Dialog from '../../common/Dialog';
import PriceInfoToolTip from './PriceInfoAB/PriceInfo';
import PromoSlot from './PromoSlot';
import { AuthContext } from '../../../Contexts';
const printJs = typeof window !== 'undefined' ? require('print-js') : undefined;

const AuthenticateModal = loadable(() =>
  import('../../HomeDeliveryNew/AuthenticateModal')
);
const PfizerModal = loadable(() => import('../PfizerModal/index.jsx'));

const CouponModal = ({
  item,
  drugData,
  isProceedClicked,
  handlepFizer,
  selectedDisplayQuantity,
  doNotMarket,
  position,
  userPoints,
  lowestPrice,
  lowestPricePharmacyName,
  maxPharmacyPosition,
  geniusRxPrice,
  customQuantity,
  isFromSavedPage,
  referralLink,
  couponShowHideInfoFunc = {},
  isModalOpen = false,
  setModalVisibility = () => {},
  showSignupModal = false,
  setSignupModal = () => {},
  drugInformationOverrideSeoName = '',
  drugName,
  pdfUrlFirstPos,
  hiddenParamsFirstPos
}) => {
  const [isContactLoading, setContactLoading] = useState(true);
  const [isWalletUrlLoading, setIsWalletUrlLoading] = useState(false);
  const [sendType, setSendType] = useState('');
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfLoading, setPdfLoading] = useState(false);
  /* set showPfizer to false to skip pfizer drugs modal
      if need to set it again use "isLegalEligible" key from tieredPricingData
   */
  const [showPfizer, setShowPzifer] = useState(false);
  const [sentMessage, setSentMessage] = useState(true);
  const [isEmailFlag, setFlag] = useState(true);
  const [contactSent, updateContactSent] = useState(false);
  const [showPopOver, togglePopOver] = useState(false);
  const [isCouponSaved, setIsCouponSaved] = useState(false);
  const [saveCouponError, setSaveCouponError] = useState(false);
  const [isLoyalty, setISLoyalty] = useState(false);
  const [hiddenParams, setHiddenParams] = useState(hiddenParamsFirstPos);
  const [buttonDisabled, setButtonDisabled] = useState('');
  const [scrollTo, setScrollTo] = useState('');
  const [fetchContactError, setFetchContactError] = useState(false);
  const [showContactSentMsg, setShowContactSentMsg] = useState(false);

  const cheapestPrice = item.Prices[0];
  const { t, i18n } = useTranslation();

  const savedCouponsData = useSelector(state => state.userDrugs.savedCoupons);
  const currentCouponData = useSelector(state => state.userDrugs.couponData);
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const isAndroid =
    typeof window !== 'undefined' &&
    /(android)/i.test(window.navigator.userAgent);

  const dispatch = useDispatch();
  const history = useHistory();
  const drugDisplayName = !_.isEmpty(drugInformationOverrideSeoName)
    ? `${drugName} (${drugData?.name})`
    : drugData?.name;
  let isCouponAddedinBasket = false;
  let couponShowHideInfoTooltipFunc = useRef(null);

  if (isLoggedIn) {
    isCouponAddedinBasket =
      _.findIndex(savedCouponsData.flattenedData, {
        ndc: drugData.ndc,
        quantity: _.isEmpty(customQuantity)
          ? Number(drugData.quantity)
          : Number(customQuantity),
        nabp: item.Pharmacy.nabp
      }) !== -1;
  }

  const hideInfoToolTip = () => {
    !_.isNull(couponShowHideInfoTooltipFunc.current) &&
      couponShowHideInfoTooltipFunc.current();
  };

  useEffect(() => {
    couponShowHideInfoFunc.current = hideInfoToolTip;
  }, []);

  useEffect(() => {
    if (
      isLoggedIn &&
      !_.isEmpty(currentCouponData.item) &&
      currentCouponData.item.Pharmacy.Name === item.Pharmacy.Name
    ) {
      saveCouponToBasket();
      closeDialog();
      dispatch(setCouponData({}));
      dispatch(setSavedLinkClick(false));
      history.push(_.withLocale(i18n.language, '/save-drugs'));
    }
  }, [currentCouponData]);

  useEffect(() => {
    if (contactSent) {
      if (
        isLoggedIn ||
        HIDE_LOYALTY_MODAL_PHARMA_LIST.includes(item.Pharmacy.Name)
      ) {
        setShowContactSentMsg(true);
        togglePopOver(false);
        updateContactSent(false);
      }
    }
  }, [contactSent]);

  useEffect(() => {
    if (showContactSentMsg) {
      setTimeout(() => {
        setShowContactSentMsg(false);
      }, 5000);
    }
  }, [showContactSentMsg]);

  const closeButtonRef = useRef();

  let eventObj = {
    memberBalance: userPoints,
    drugName: drugData.name,
    seoName: drugData.seoName,
    NDC: cheapestPrice.preferredNdc,
    drugBrand: drugData?.drugType
      ? drugData?.drugType
      : drugData.isGeneric
      ? 'generic'
      : 'brand',
    drugForm: drugData.form,
    drugDosage: drugData.dosage,
    drugQuantity: drugData.quantity,
    drugQuantityUnit: 'count',
    pbm: cheapestPrice.pBAName,
    pharmacyPrice: cheapestPrice.Price,
    priceUsualAndCustomary: cheapestPrice.UsualAndCustomary,
    singlecarePrice: cheapestPrice.Price,
    lowestPrice: lowestPrice,
    lowestPricePharmacyName: lowestPricePharmacyName,
    loyaltyApplicable: cheapestPrice.LoyaltyApplicable,
    loyaltyBonusSavings: cheapestPrice.LoyaltyBonusSavings,
    loyaltyExcluded: cheapestPrice.LoyaltyExcluded,
    loyaltyPrice: cheapestPrice.LoyaltyPrice,
    maxPharmacyPosition: maxPharmacyPosition,
    GPI: drugData.gpi,
    network: item.Pharmacy.network,
    pharmacyNetPrice: cheapestPrice.LoyaltyPrice,
    memberSavings: !_.isEmpty(cheapestPrice.LoyaltyDiscounts)
      ? cheapestPrice.LoyaltyDiscounts[0].discountAmount
      : '',
    bonusSavings: cheapestPrice.LoyaltyBonusSavings
  };
  let sendCouponObj = {
    ...eventObj,
    pharmacyName: item.Pharmacy.Name,
    pharmacyPosition: position,
    pharmacyDistance: item.Pharmacy.Distance
  };

  useEffect(() => {
    if (!_.isEmpty(pdfUrlFirstPos)) {
      setContactLoading(false);
      setPdfUrl(pdfUrlFirstPos);
    } else {
      isModalOpen ? fetchContactData() : setPdfUrl('');
    }
  }, [isModalOpen]);

  // Fetch Coupon Data
  const fetchContactData = async () => {
    await setContactLoading(true);
    try {
      const { PartnerUser, PartnerPassword } = item.Prices[0];
      const contactResponse = await fetchCouponData(
        PartnerUser,
        PartnerPassword,
        '65',
        {},
        drugData.seoName,
        cheapestPrice.Price,
        cheapestPrice.LoyaltyApplicable,
        cheapestPrice.LoyaltyExcluded,
        cheapestPrice.LoyaltyBonusSavings,
        cheapestPrice.preferredNdc
      );
      if (!_.isEmpty(contactResponse.PDFUrl))
        await setPdfUrl(contactResponse.PDFUrl);
      else await setFetchContactError(true);
      if (!_.isEmpty(contactResponse)) {
        let finalEventObj = {
          ...eventObj,
          event: 'couponGenerated',
          authNumber: contactResponse.MemberNumberFull,
          grpNumber: contactResponse.GroupNumber,
          bin: contactResponse.BIN,
          pcn: contactResponse.PCN,
          geniusRxPrice
        };
        setHiddenParams({
          authNumber: contactResponse.MemberNumberFull,
          grpNumber: contactResponse.GroupNumber,
          bin: contactResponse.BIN,
          pcn: contactResponse.PCN
        });
        _.triggerGTMVirtualPageViewEvent(finalEventObj);
        _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.GENERATE_COUPON);
        _.sendIntellimizeEvent(
          INTELLIMIZE_COUPON_EVENT.PRESCRIPTION_COUPON_GENERATE
        );
      }
    } catch (err) {
      console.log(err);
      setFetchContactError(true);
    } finally {
      await setContactLoading(false);
    }
  };

  useEffect(() => {
    if (scrollTo === 'scroll') {
      _.getIsMobileDevice() && !window.location.pathname.includes('save-drugs')
        ? document
            .getElementById(`get-coupon-${position}`)
            .scrollIntoView({ behavior: 'auto', block: 'center' })
        : null;
    }
    return setScrollTo('');
  }, [scrollTo]);

  const closeInput = () => {
    togglePopOver(false);
    setScrollTo('scroll');
    updateContactSent(false);
  };

  const toggleTrueFalse = (event = { preventDefault() {} }) => {
    event.preventDefault();
    togglePopOver(true);
    setFlag(event.target.id === 'email');
    setSentMessage(
      event.target.id === 'email'
        ? 'success_msgEmail_sent'
        : 'success_msgText_sent'
    );
    setSendType(event.target.id);
    _.triggerGTMVirtualPageViewEvent({
      ...sendCouponObj,
      event:
        event.target.id === 'email'
          ? 'couponEmailButtonClick'
          : 'couponTextButtonClick',
      buttonLocation: 'coupon_modal',
      chainCode: item.Pharmacy.chainCode
    });
    _.sendIntellimizeEvent(
      event.target.id === 'email'
        ? INTELLIMIZE_COUPON_EVENT.COUPON_EMAIL_BUTTON_CLICK
        : INTELLIMIZE_COUPON_EVENT.COUPON_TEXT_BUTTON_CLICK
    );
    setISLoyalty(false);
    setButtonDisabled(event.target.id);
  };

  const handlePrintClick = async (event = { preventDefault() {} }) => {
    event.preventDefault();
    setPdfLoading(true);
    setSentMessage('success_msgPrint_sent');
    try {
      const { PartnerUser, PartnerPassword } = item.Prices[0];
      const pdfParams = {
        drug: doNotMarket ? 'Your Prescription' : drugData.name,
        qty: selectedDisplayQuantity,
        form: drugData.form,
        price: `${
          isLoggedIn && cheapestPrice.LoyaltyApplicable
            ? cheapestPrice.LoyaltyPrice
            : cheapestPrice.Price
        }`,
        dsg: drugData.dosage,
        pharmacy: item.Pharmacy.Name
      };
      const couponData = await fetchCouponData(
        PartnerUser,
        PartnerPassword,
        '2',
        pdfParams,
        drugData.seoName,
        cheapestPrice.Price,
        cheapestPrice.LoyaltyApplicable,
        cheapestPrice.LoyaltyExcluded,
        cheapestPrice.LoyaltyBonusSavings,
        cheapestPrice.preferredNdc
      );
      if (!_.isEmpty(couponData.PDFUrl)) {
        _.triggerGTMVirtualPageViewEvent({
          ...sendCouponObj,
          event: 'printCouponGenerated',
          buttonLocation: 'coupon_modal',
          chainCode: item.Pharmacy.chainCode,
          authNumber: couponData.MemberNumberFull,
          grpNumber: couponData.GroupNumber,
          bin: couponData.BIN,
          pcn: couponData.PCN
        });
        _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.PRINT_COUPON_GENERATED);
        printJs({
          printable: couponData.PDFUrl,
          type: 'image'
        });
        setPdfLoading(false);
        togglePopOver(true);
        updateContactSent(true);
      }
    } catch (err) {
      console.log(err);
      setPdfLoading(false);
    }
  };

  const handlePfizerClose = () => {
    setShowPzifer(false);
    handlepFizer();
  };

  const saveCouponToBasket = async () => {
    const formData = {
      ndc: drugData.ndc,
      quantity: _.isEmpty(customQuantity)
        ? Number(drugData.quantity)
        : parseInt(customQuantity),
      nabp: item.Pharmacy.nabp,
      pharmacy: item.Pharmacy.Name,
      isCustomQuantity: !_.isEmpty(customQuantity)
    };
    const saveCouponData = await saveCoupon(formData);
    if (saveCouponData && saveCouponData.success) {
      _.triggerGTMVirtualPageViewEvent({
        event: 'saveCoupon'
      });
      _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.COUPON_MODAL_SAVE_COUPON);
      setShowContactSentMsg(false);
      setIsCouponSaved(true);
      dispatch(getSavedCoupons());
      setTimeout(() => {
        setIsCouponSaved(false);
      }, 3000);
    } else {
      const errorMessage =
        saveCouponData.message.code === 6
          ? 'This coupon is already saved.'
          : 'Something went wrong.';
      setSaveCouponError(errorMessage);
      setTimeout(() => {
        setSaveCouponError('');
      }, 3000);
    }
  };

  const closePopups = () => {
    if (!_.isEmpty(currentCouponData.item)) {
      setSignupModal(false);
      isLoggedIn && dispatch(setCouponData({}));
    } else {
      setSignupModal(false);
      updateContactSent(false);
      closeInput();
      setModalVisibility(false);
      dispatch(modalActions.clearModal());
    }
  };

  const closeForLoyaltyPopups = () => {
    setSignupModal(false);
    setISLoyalty(false);
    closeInput();
    // setModalVisibility(false);
    dispatch(modalActions.clearModal());
  };

  const handleLoyaltySignUpClick = () => {
    setSignupModal(true);
    setISLoyalty(true);
    let { signUpPath, signUpPathWithInvite } =
      _.getSignUpPath(LOYALTY_SIGNUP_MODAL);
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpButtonClick',
      ...signUpPath
    });
    _.triggerGTMVirtualPageViewEvent({
      event: 'signupModalOpen',
      referralLink: referralLink,
      ...signUpPathWithInvite
    });
    _.sendIntellimizeEvent(INTELLIMIZE_LOYALTY_SIGN_UP_STARTED);
    dispatch(modalActions.loyaltySignupModal());
  };

  const showDistance = item => {
    if (!item.Pharmacy.onlinePharmacy) {
      return !isFromSavedPage ? (
        <div className="pharmacyDistance">
          {Number(item.Pharmacy.Distance).toFixed(2)}
          <span className="miles"> {t('mi. away')}</span>
        </div>
      ) : (
        ''
      );
    }
    return (
      <div className="pharmacyDistance">
        <span>{t('Online only')}</span>
      </div>
    );
  };

  const setFocusToCloseButton = event => {
    if (!_.isEmpty(event.relatedTarget)) {
      let relatedClassName = event.relatedTarget.className;
      if (relatedClassName.includes('dialogComponent')) {
        return;
      } else {
        closeButtonRef.current.focus();
      }
    }
  };

  const closeDialog = () => {
    if (contactSent) {
      closeInput();
      updateContactSent(false);
      closeButtonRef.current.focus();
      setButtonDisabled('');
    } else {
      setModalVisibility(false);
      closeInput();
      // Todo check here to close for new login flow
      dispatch(modalActions.clearModal());
      setButtonDisabled('');
    }
  };

  const handleSaveCoupon = () => {
    if (isLoggedIn) {
      saveCouponToBasket();
    } else {
      dispatch(setCouponData({ item }));
      dispatch(setSavedLinkClick(true));
      setSignupModal(true);
    }
  };
  const handleUnSaveCoupon = async () => {
    const formData = {
      ndc: drugData.ndc,
      quantity: _.isEmpty(customQuantity)
        ? Number(drugData.quantity)
        : parseInt(customQuantity),
      nabp: item.Pharmacy.nabp,
      pharmacy: item.Pharmacy.Name,
      isCustomQuantity: !_.isEmpty(customQuantity)
    };
    isCouponAddedinBasket =
      _.findIndex(savedCouponsData.flattenedData, {
        ndc: drugData.ndc,
        quantity: _.isEmpty(customQuantity)
          ? Number(drugData.quantity)
          : Number(customQuantity),
        nabp: item.Pharmacy.nabp
      }) !== -1;
    if (isCouponAddedinBasket) {
      const deletePharmcyResponse = await deletePharmacyCoupon(
        formData,
        savedCouponsData.saveCouponId
      );
      if (deletePharmcyResponse && deletePharmcyResponse.saveCouponId) {
        setIsCouponSaved(false);

        dispatch(getSavedCoupons());
        if (isFromSavedPage) {
          document.body.style.overflow = '';
          document.body.style.position = '';
          setModalVisibility(false);
        }
        _.triggerGTMVirtualPageViewEvent({
          event: 'deleteCouponConfirm',
          drugName: eventObj.drugName,
          seoName: eventObj.seoName,
          NDC: eventObj.NDC,
          drugBrand: eventObj.drugBrand,
          drugForm: eventObj.form,
          drugDosage: eventObj.dosage,
          drugQuantity: eventObj.quantity,
          pharmacyName: eventObj.pharmacy,
          chainCode: eventObj.chainCode,
          pharmacyPrice: eventObj.price,
          loyaltyPrice: eventObj.loyaltyPrice,
          loyaltyApplicable: eventObj.loyaltyApplicable,
          loyaltyExcluded: eventObj.loyaltyExcluded,
          bonusSavings: eventObj.loyaltyBonusSavings,
          GPI: eventObj.GPI,
          pharmacyDistance: eventObj.distance
        });
      }
    }
  };

  const getPharmacyALTWithTranslation = PharmacyName => {
    let pharmacyName = '';
    pharmacyName = _.endsWith(_.lowerCase(PharmacyName), 'pharmacy')
      ? PharmacyName
      : `${PharmacyName} Pharmacy`;
    return i18n.language === 'en'
      ? pharmacyName + ' ' + t('Logo')
      : t('Logo') + ' ' + pharmacyName;
  };

  const addToWalletHandler = async (e, item) => {
    e.preventDefault();
    const { PartnerUser, PartnerPassword, LoyaltyPrice, preferredNdc } =
      item.Prices[0];
    let data = {
      pId: PartnerUser,
      pPass: PartnerPassword,
      contactTypeId: 92,
      drug: drugData?.name,
      pharmacy: item?.Pharmacy.Name,
      Price: LoyaltyPrice,
      Form: drugData.form,
      dsg: drugData.dosage,
      qty: drugData.quantity,
      isCard: false,
      preferredNdc: preferredNdc
    };
    let dataLayerEventObj = {
      event: 'addToWallet',
      os: isAndroid ? 'android' : 'ios',
      ndc: preferredNdc,
      ...sendCouponObj,
      ...hiddenParams
    };
    setIsWalletUrlLoading(true);
    let resp = await addToWallet(data);
    if (resp?.Result && resp?.Result?.WalletCouponURL) {
      const walletCouponURL = resp?.Result?.WalletCouponURL;
      if (resp?.Result?.Contact?.MemberNumberFull)
        dataLayerEventObj.authNumber = resp?.Result?.Contact?.MemberNumberFull;
      _.triggerGTMVirtualPageViewEvent(dataLayerEventObj);
      _.sendIntellimizeEvent(INTELLIMIZE_COUPON_EVENT.COUPON_ADDEDTOWALLET);
      setIsWalletUrlLoading(false);
      window.location.assign(
        walletCouponURL?.GoogleWallet,
        walletCouponURL?.AppleWallet
      );
    }
  };

  return (
    <>
      <div>
        {showSignupModal ? (
          <div className="mainModal afterSignupmodal">
            <div
              className="transparentBg"
              onClick={() =>
                isLoyalty ? closeForLoyaltyPopups() : closePopups()
              }
            ></div>
            <div className="signUpModal">
              <AuthenticateModal
                hideAuthenticateModal={() =>
                  isLoyalty ? closeForLoyaltyPopups() : closePopups()
                }
              />
            </div>
          </div>
        ) : (
          isModalOpen && (
            <div className="mainModal prescriptionModal">
              <div
                className={`transparentBg ${
                  contactSent && 'sentSuccessTransparentBg'
                }`}
                onClick={() => {
                  setModalVisibility(false);
                  closeInput();
                  dispatch(modalActions.clearModal());
                }}
              ></div>
              <Dialog
                className={`mainModalContent mainCouponModal ${
                  cheapestPrice.LoyaltyApplicable && 'loginInfoContent'
                } ${isLoggedIn && 'afterloginCouponModal'} ${
                  contactSent &&
                  !HIDE_LOYALTY_MODAL_PHARMA_LIST.includes(
                    item.Pharmacy.Name
                  ) &&
                  'sentSuccessModal'
                }`}
                onBlur={setFocusToCloseButton}
                escKeyFunction={closeDialog}
                isModalOpen={isModalOpen}
              >
                <DialogCloseButton
                  className="closeModal whiteFocus"
                  onClick={() => {
                    closeDialog();
                  }}
                  ref={closeButtonRef}
                  img="icon-close-white.svg"
                  alt=""
                />
                <h2 id="dialogTitleHeading">
                  {doNotMarket ? 'Your Prescription' : drugDisplayName}
                  <span>
                    {selectedDisplayQuantity} {drugData.form},&nbsp;
                    {drugData.dosage}
                  </span>
                </h2>
                {isCouponSaved && (
                  <div className="couponSavedBanner">
                    <p>
                      {`Saved! `}See all your&nbsp;
                      <a
                        onClick={() => {
                          localStorage.setItem(
                            'saveDrugGTM',
                            'seeAllYourSavedCouponsBanner'
                          );
                        }}
                        href="/save-drugs"
                      >
                        saved coupons.
                      </a>
                    </p>
                  </div>
                )}
                {!_.isEmpty(saveCouponError) && (
                  <div className="notification visible savedDrugNotification">
                    {saveCouponError}
                    <span
                      className="close-button"
                      onClick={() => setSaveCouponError('')}
                    >
                      ×
                    </span>
                  </div>
                )}
                <div className="pharmacyListContent">
                  {showContactSentMsg && (
                    <div className="emailTextSend">
                      <p>{t(sentMessage)}</p>
                    </div>
                  )}
                  {!fetchContactError && (
                    <div className="pharmacyList">
                      <div className="pharmacyLocation">
                        {item.Pharmacy.LogoUrl && (
                          <div className="logo">
                            <img
                              className="logo"
                              src={item.Pharmacy.LogoUrl}
                              alt={getPharmacyALTWithTranslation(
                                item.Pharmacy.Name
                              )}
                            />
                          </div>
                        )}
                        {!item.Pharmacy.LogoUrl && (
                          <div className="logo pharmacyTextLogo">
                            <p>{item.Pharmacy.Name}</p>
                          </div>
                        )}
                        {showDistance(item)}
                      </div>
                      {/*<div className="mobile-only fullwidth">
                    <div className="pharmacyAvgPrice ">
                      <label> Avg. Retail Price </label>
                      <span> ${currentPrice} </span>
                      <span className="FinalPrice">${currentPrice}</span>
                    </div>
                  </div>*/}
                      <div
                        className="pharmacyAvgPrice"
                        data-loyaltyapplicable={cheapestPrice.LoyaltyApplicable}
                        data-formattedprice={cheapestPrice.formattedPrice}
                        data-loyaltyprice={cheapestPrice.LoyaltyPrice}
                        data-loyaltybonussavings={
                          cheapestPrice.LoyaltyBonusSavings
                        }
                        data-loyaltyexcluded={cheapestPrice.LoyaltyExcluded}
                      >
                        <PriceInfoToolTip
                          isLoggedIn={isLoggedIn}
                          cheapestPrice={cheapestPrice}
                          handleLoyaltySignUpClick={handleLoyaltySignUpClick}
                          eventObj={eventObj}
                          couponShowHideInfoTooltipFunc={
                            couponShowHideInfoTooltipFunc
                          }
                          pharmacyName={item.Pharmacy.Name}
                        />
                      </div>
                    </div>
                  )}

                  {isLoggedIn && !cheapestPrice.LoyaltyExcluded && (
                    <div className="earnCoupon">
                      <div className="earnCouponContent">
                        <p>
                          <span> {t('Earn')} $1 </span>{' '}
                          {t('when you fill this script')}
                        </p>
                      </div>
                    </div>
                  )}
                  {showPfizer && !isProceedClicked ? (
                    <PfizerModal handlePfizerClick={handlePfizerClose} />
                  ) : !fetchContactError ? (
                    <div className="couponMainWrapper">
                      <div className="textCenter pharmacyNote">
                        {t('Show this free card to your pharmacist')}
                        &nbsp;{t('at')}&nbsp;
                        <span>{item.Pharmacy.Name}</span>.&nbsp;
                      </div>
                      {isContactLoading ? (
                        <div className="loaderContainer">
                          <img
                            src="/content/images/loader/loading.gif"
                            alt={t('Coupon card loading')}
                            className="couponLoader"
                          />
                        </div>
                      ) : (
                        <div className="flexContent">
                          <div
                            className="couponCard"
                            data-bin={hiddenParams.bin}
                            data-pcn={hiddenParams.pcn}
                            data-groupnumber={hiddenParams.grpNumber}
                            data-authnumber={hiddenParams.authNumber}
                            data-pharmacyname={item.Pharmacy.Name}
                            data-logourl={item.Pharmacy.LogoUrl}
                          >
                            {pdfUrl && (
                              <Image
                                imageUrl={pdfUrl}
                                imageAlt={t('discount-card-param', {
                                  pharmacy: _.getPharmacyALTName(
                                    item.Pharmacy.Name
                                  )
                                })}
                                imageClass="contactImage"
                                containerClass="imageContainer"
                                loaderClass="loaderImage"
                                loaderalt={t('Coupon card loading')}
                                role="progressbar"
                              />
                            )}
                          </div>

                          <ul className="actionButton">
                            {i18n.language === 'en' && (
                              <li className="saveSection hide">
                                {isCouponAddedinBasket ? (
                                  <button
                                    onClick={handleUnSaveCoupon}
                                    className="button savebtn text-button-padding themeFocus dialogComponent"
                                  >
                                    Unsave coupon
                                  </button>
                                ) : (
                                  <button
                                    onClick={handleSaveCoupon}
                                    className="button text-button-padding savebtn themeFocus dialogComponent"
                                  >
                                    Save coupon
                                  </button>
                                )}
                              </li>
                            )}
                            <li>
                              <button
                                className={`button pink text-send text-button-padding themeFocus dialogComponent ${
                                  buttonDisabled === 'text' && 'disableButton'
                                }`}
                                id="text"
                                onClick={toggleTrueFalse}
                                onMouseDown={e => e.preventDefault()}
                              >
                                {t('Text')}
                              </button>
                            </li>
                            <li>
                              <button
                                className={`button pink email-send email-button-padding themeFocus dialogComponent ${
                                  buttonDisabled === 'email' && 'disableButton'
                                }`}
                                id="email"
                                onClick={toggleTrueFalse}
                                onMouseDown={e => e.preventDefault()}
                              >
                                {t('Email')}
                              </button>
                            </li>
                            {pdfLoading ? (
                              <img
                                src="/content/images/loader/loading.gif"
                                alt="loader"
                                className="pdfLoader"
                              />
                            ) : (
                              i18n.language === 'en' && (
                                <li className="desktop-only">
                                  <button
                                    className="button pinkBorderButton print-button print-button-padding themeFocus dialogComponent"
                                    onClick={handlePrintClick}
                                  >
                                    {t('Print')}
                                  </button>
                                </li>
                              )
                            )}
                            {i18n.language === 'en' && (
                              <li className="saveSection updatedSection hide">
                                {isCouponAddedinBasket ? (
                                  <button className="button savebtn text-button-padding themeFocus disabled pointerNone dialogComponent">
                                    Saved
                                  </button>
                                ) : (
                                  <button
                                    onClick={handleSaveCoupon}
                                    className="button text-button-padding savebtn themeFocus dialogComponent"
                                  >
                                    Save
                                  </button>
                                )}
                              </li>
                            )}
                          </ul>
                        </div>
                      )}
                      {item.Prices[0].PBAClientName ===
                        WALMART_PBA_CLIENT_NAME &&
                        !contactSent && (
                          <div className="pharmacy-item__pricing-msg">
                            <p className="item__pricing">
                              {t('WALMART_PHARMACY_DESCRIPTION_2')}
                            </p>
                          </div>
                        )}
                    </div>
                  ) : (
                    <div className="errorCardImgMain">
                      <h4>{t('ErrorHead')}</h4>
                      <p>{t('ErrorPara1')}</p>
                      <p>{t('ErrorPara2')}</p>
                    </div>
                  )}

                  <div
                    className={`actionModal ${
                      showPopOver ? 'showModal' : 'hideModal'
                    } ${contactSent && 'purpleSuccessModal'}
                    ${
                      !_.isEmpty(sentMessage) && !contactSent
                        ? 'emailInputBox'
                        : ''
                    } 
                    ${
                      sendType === 'text' && !contactSent ? 'textInputBox' : ''
                    }`}
                    aria-modal={
                      contactSent || showContactSentMsg ? true : false
                    }
                  >
                    {showPopOver && (
                      <SendContact
                        isEmail={sendType === 'email'}
                        drugData={drugData}
                        selectedPrice={cheapestPrice}
                        selectedPharmacyName={item.Pharmacy.Name}
                        buttonClicked={
                          sendType === 'email' || sendType === 'text'
                        }
                        doNotMarket={doNotMarket}
                        selectedDisplayQuantity={selectedDisplayQuantity}
                        setSignupModal={setSignupModal}
                        contactSent={contactSent}
                        updateContactSent={updateContactSent}
                        eventObj={sendCouponObj}
                        sentMessage={sentMessage}
                      />
                    )}
                  </div>

                  <div>
                    {showPfizer && !isProceedClicked ? (
                      <PfizerModal handlePfizerClick={handlePfizerClose} />
                    ) : (
                      <div className="mobile-only">
                        <div className="couponMainSection">
                          {isContactLoading ? (
                            <div className="loaderContainer">
                              <img
                                src="/content/images/loader/loading.gif"
                                alt={t('Coupon card loading')}
                                className="couponLoader"
                              />
                            </div>
                          ) : (
                            <div className="flexContent">
                              <div
                                className="couponCard"
                                data-bin={hiddenParams.bin}
                                data-pcn={hiddenParams.pcn}
                                data-groupnumber={hiddenParams.grpNumber}
                                data-authnumber={hiddenParams.authNumber}
                                data-pharmacyname={item.Pharmacy.Name}
                                data-logourl={item.Pharmacy.LogoUrl}
                              >
                                {pdfUrl && (
                                  <Image
                                    imageUrl={pdfUrl}
                                    imageAlt={t('discount-card-param', {
                                      pharmacy: _.getPharmacyALTName(
                                        item.Pharmacy.Name
                                      )
                                    })}
                                    imageClass="contactImage"
                                    containerClass="imageContainer"
                                    loaderClass="loaderImage"
                                    loaderalt={t('Coupon card loading')}
                                    role="progressbar"
                                  />
                                )}
                              </div>

                              <ul className="actionButton">
                                {i18n.language === 'en' && (
                                  <li className="saveSection hide">
                                    {isCouponAddedinBasket ? (
                                      <button className="button savebtn text-button-padding themeFocus disabled pointerNone dialogComponent">
                                        Coupon saved
                                      </button>
                                    ) : (
                                      <button
                                        onClick={handleSaveCoupon}
                                        className="button text-button-padding savebtn themeFocus dialogComponent"
                                      >
                                        Save coupon
                                      </button>
                                    )}
                                  </li>
                                )}
                                <li
                                  className={`${
                                    buttonDisabled === 'text' && 'buttonHide'
                                  }`}
                                >
                                  <button
                                    className={`button pink text-send text-button-padding themeFocus dialogComponent `}
                                    id="text"
                                    onClick={toggleTrueFalse}
                                  >
                                    {t('Text')}
                                  </button>
                                </li>
                                <li className="newSendForm">
                                  <div
                                    className={`actionModal actionNewModal ${
                                      showPopOver ? 'showModal' : 'hideModal'
                                    } ${
                                      contactSent &&
                                      !isLoggedIn &&
                                      'purpleSuccessModal'
                                    }`}
                                  >
                                    {showPopOver && (
                                      <SendContact
                                        isEmail={sendType === 'email'}
                                        drugData={drugData}
                                        selectedPrice={cheapestPrice}
                                        selectedPharmacyName={
                                          item.Pharmacy.Name
                                        }
                                        buttonClicked={
                                          sendType === 'email' ||
                                          sendType === 'text'
                                        }
                                        doNotMarket={doNotMarket}
                                        selectedDisplayQuantity={
                                          selectedDisplayQuantity
                                        }
                                        setSignupModal={setSignupModal}
                                        contactSent={contactSent}
                                        updateContactSent={updateContactSent}
                                        eventObj={sendCouponObj}
                                        sentMessage={sentMessage}
                                      />
                                    )}
                                  </div>
                                </li>
                                <li
                                  className={`${
                                    buttonDisabled === 'email' && 'buttonHide'
                                  }`}
                                >
                                  <button
                                    className={`button pink email-send email-button-padding themeFocus dialogComponent `}
                                    id="email"
                                    onClick={toggleTrueFalse}
                                  >
                                    {t('Email')}
                                  </button>
                                </li>
                                {pdfLoading ? (
                                  <img
                                    src="/content/images/loader/loading.gif"
                                    alt="loader"
                                    className="pdfLoader"
                                  />
                                ) : (
                                  i18n.language === 'en' && (
                                    <li className="desktop-only">
                                      <button
                                        className="button pinkBorderButton print-button print-button-padding themeFocus dialogComponent"
                                        onClick={handlePrintClick}
                                      >
                                        {t('Print')}
                                      </button>
                                    </li>
                                  )
                                )}
                                {i18n.language === 'en' && (
                                  <li className="saveSection updatedSection hide">
                                    {isCouponAddedinBasket ? (
                                      <button className="button savebtn text-button-padding themeFocus disabled pointerNone dialogComponent">
                                        Saved
                                      </button>
                                    ) : (
                                      <button
                                        onClick={handleSaveCoupon}
                                        className="button text-button-padding savebtn themeFocus dialogComponent"
                                      >
                                        Save
                                      </button>
                                    )}
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                          {item.Prices[0].PBAClientName ===
                            WALMART_PBA_CLIENT_NAME &&
                            !contactSent && (
                              <div className="pharmacy-item__pricing-msg">
                                <p className="item__pricing">
                                  {t('WALMART_PHARMACY_DESCRIPTION_2')}
                                </p>
                              </div>
                            )}
                          <div className="textCenter pharmacyNote">
                            {t('Show this free card to your pharmacist')}
                            &nbsp;{t('at')}&nbsp;
                            <span>{item.Pharmacy.Name}</span>.&nbsp;
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="walletAction">
                    {isWalletUrlLoading ? (
                      <div className="loaderContainer wallet">
                        <img
                          src="/content/images/loader/loading.gif"
                          alt={t('Coupon card loading')}
                          className="couponLoader"
                        />
                      </div>
                    ) : (
                      <div
                        className="wallet"
                        onClick={e => addToWalletHandler(e, item)}
                      >
                        {isAndroid ? (
                          <img
                            alt="android wallet"
                            className="android-img"
                            src={
                              i18n.language === 'en'
                                ? '/content/images/prescriptions/android-wallet.svg'
                                : '/content/images/prescriptions/android-wallet-es.svg'
                            }
                          />
                        ) : (
                          <img
                            alt="apple wallet"
                            className="apple-img"
                            src={
                              i18n.language === 'en'
                                ? '/content/images/prescriptions/apple-wallet.svg'
                                : '/content/images/prescriptions/apple-wallet-es.svg'
                            }
                          />
                        )}
                      </div>
                    )}
                  </div>
                  <div className="mobile-only">
                    <PromoSlot
                      iconImg="/content/images/icons/appIconNew.svg"
                      heading={t('Switch to the free app')}
                      linkText={t('Install now')}
                      linkUrl="https://singlecare.onelink.me/OxIQ/c8fe6bf"
                    />
                  </div>
                </div>
              </Dialog>
            </div>
          )
        )}
      </div>
      <div>
        {showSignupModal ? (
          <div className="mainModalNew afterSignupmodal">
            <div
              className="transparentBg"
              onClick={() =>
                isLoyalty ? closeForLoyaltyPopups() : closePopups()
              }
            ></div>
            <div className="signUpModal">
              <AuthenticateModal
                hideAuthenticateModal={() =>
                  isLoyalty ? closeForLoyaltyPopups() : closePopups()
                }
              />
            </div>
          </div>
        ) : (
          isModalOpen && (
            <div className="mainModalNew prescriptionModal">
              <div
                className={`transparentBg ${
                  contactSent && 'sentSuccessTransparentBg'
                }`}
                onClick={() => {
                  setModalVisibility(false);
                  closeInput();
                  dispatch(modalActions.clearModal());
                }}
              ></div>
              <Dialog
                className={`mainModalContent mainCouponModal ${
                  cheapestPrice.LoyaltyApplicable && 'loginInfoContent'
                } ${isLoggedIn && 'afterloginCouponModal'} ${
                  contactSent &&
                  !HIDE_LOYALTY_MODAL_PHARMA_LIST.includes(
                    item.Pharmacy.Name
                  ) &&
                  'sentSuccessModal'
                }`}
                onBlur={setFocusToCloseButton}
                escKeyFunction={closeDialog}
                isModalOpen={isModalOpen}
              >
                <DialogCloseButton
                  className="closeModal whiteFocus"
                  onClick={() => {
                    closeDialog();
                  }}
                  ref={closeButtonRef}
                  img="icon-close-white.svg"
                  alt=""
                />
                <h2 id="dialogTitleHeading">
                  Your {doNotMarket ? 'Your Prescription' : drugDisplayName}{' '}
                  coupon
                </h2>
                {isCouponSaved && (
                  <div className="couponSavedBanner">
                    <p>
                      {`Saved! `}See all your&nbsp;
                      <a
                        onClick={() => {
                          localStorage.setItem(
                            'saveDrugGTM',
                            'seeAllYourSavedCouponsBanner'
                          );
                        }}
                        href="/save-drugs"
                      >
                        saved coupons.
                      </a>
                    </p>
                  </div>
                )}
                {!_.isEmpty(saveCouponError) && (
                  <div className="notification visible savedDrugNotification">
                    {saveCouponError}
                    <span
                      className="close-button"
                      onClick={() => setSaveCouponError('')}
                    >
                      ×
                    </span>
                  </div>
                )}
                <div className="pharmacyListContent">
                  {showContactSentMsg && (
                    <div className="emailTextSend">
                      <p>
                        {t(
                          isEmailFlag
                            ? 'success_msgEmail_sent'
                            : 'success_msgText_sent'
                        )}
                      </p>
                    </div>
                  )}
                  {!fetchContactError && (
                    <div className="new-prescription-modal">
                      <div className="left-section">
                        <div className="drug-name">{drugDisplayName}</div>
                        <div className="dosage">
                          {selectedDisplayQuantity} {drugData.form},&nbsp;
                          {drugData.dosage}
                        </div>
                        {item?.Pharmacy && item.Pharmacy.LogoUrl ? (
                          <div className="pharmacy-logo">
                            <img
                              className="logo"
                              src={item.Pharmacy.LogoUrl}
                              alt={item.Pharmacy.Name}
                            />
                          </div>
                        ) : (
                          <div className="pharmacy-name">
                            {item.Pharmacy.Name}
                          </div>
                        )}
                        {item?.Pharmacy?.onlinePharmacy && (
                          <div className="onlinePharmacy">Online only</div>
                        )}
                        <hr className="separator" />
                        <div className="pharmacyList">
                          <div
                            className="pharmacyAvgPrice"
                            data-loyaltyapplicable={
                              cheapestPrice.LoyaltyApplicable
                            }
                            data-formattedprice={cheapestPrice.formattedPrice}
                            data-loyaltyprice={cheapestPrice.LoyaltyPrice}
                            data-loyaltybonussavings={
                              cheapestPrice.LoyaltyBonusSavings
                            }
                            data-loyaltyexcluded={cheapestPrice.LoyaltyExcluded}
                          >
                            <PriceInfoToolTip
                              isLoggedIn={isLoggedIn}
                              cheapestPrice={cheapestPrice}
                              handleLoyaltySignUpClick={
                                handleLoyaltySignUpClick
                              }
                              eventObj={eventObj}
                              couponShowHideInfoTooltipFunc={
                                couponShowHideInfoTooltipFunc
                              }
                              pharmacyName={item.Pharmacy.Name}
                            />
                          </div>
                        </div>
                        {isLoggedIn && !cheapestPrice.LoyaltyExcluded && (
                          <div className="earn-text">
                            <span className="text-highlight">
                              {t('Earn')} $1 {t('when you fill this script')}
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="right-section">
                        {isContactLoading ? (
                          <div className="loaderContainer">
                            <img
                              src="/content/images/loader/loading.gif"
                              alt={t('Coupon card loading')}
                              className="couponLoader"
                            />
                          </div>
                        ) : (
                          <>
                            <div
                              className="couponCard"
                              data-bin={hiddenParams.bin}
                              data-pcn={hiddenParams.pcn}
                              data-groupnumber={hiddenParams.grpNumber}
                              data-authnumber={hiddenParams.authNumber}
                              data-pharmacyname={item.Pharmacy.Name}
                              data-logourl={item.Pharmacy.LogoUrl}
                            >
                              {pdfUrl && (
                                <Image
                                  imageUrl={pdfUrl}
                                  imageAlt={t('discount-card-param', {
                                    pharmacy: _.getPharmacyALTName(
                                      item.Pharmacy.Name
                                    )
                                  })}
                                  imageClass="contactImage"
                                  containerClass="imageContainer"
                                  loaderClass="loaderImage"
                                  loaderalt={t('Coupon card loading')}
                                  role="progressbar"
                                />
                              )}
                            </div>
                            <p className="instruction">
                              Show this coupon at the pharmacy counter.
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {showPfizer && !isProceedClicked ? (
                    <PfizerModal handlePfizerClick={handlePfizerClose} />
                  ) : !fetchContactError ? (
                    <div className="couponMainWrapper">
                      {
                        <ul className="actionButton">
                          {i18n.language === 'en' && (
                            <li className="saveSection hide">
                              {isCouponAddedinBasket ? (
                                <button
                                  onClick={handleUnSaveCoupon}
                                  className="button savebtn text-button-padding themeFocus dialogComponent"
                                >
                                  Unsave coupon
                                </button>
                              ) : (
                                <button
                                  onClick={handleSaveCoupon}
                                  className="button text-button-padding savebtn themeFocus dialogComponent"
                                >
                                  Save coupon
                                </button>
                              )}
                            </li>
                          )}
                          <li>
                            <button
                              className={`button pink text-send text-button-padding themeFocus dialogComponent ${
                                buttonDisabled === 'text' && 'disableButton'
                              }`}
                              id="text"
                              onClick={toggleTrueFalse}
                              onMouseDown={e => e.preventDefault()}
                            >
                              <img
                                src="/content/images/icons/message.svg"
                                alt="message"
                                className=""
                              />
                              {t('Text')}
                            </button>
                          </li>
                          <li>
                            <button
                              className={`button pink email-send email-button-padding themeFocus dialogComponent ${
                                buttonDisabled === 'email' && 'disableButton'
                              }`}
                              id="email"
                              onClick={toggleTrueFalse}
                              onMouseDown={e => e.preventDefault()}
                            >
                              <img
                                src="/content/images/icons/email.svg"
                                alt="message"
                                className=""
                              />
                              {t('Email')}
                            </button>
                          </li>
                          {i18n.language === 'en' && (
                            <li className="desktop-only">
                              <button
                                className="button pink email-send email-button-padding themeFocus dialogComponent"
                                onClick={handlePrintClick}
                                disabled={pdfLoading}
                              >
                                {pdfLoading ? (
                                  <img
                                    src="/content/images/loader/loading.gif"
                                    alt="loader"
                                    className="pdfLoader"
                                  />
                                ) : (
                                  <>
                                    <img
                                      src="/content/images/icons/print.svg"
                                      alt="message"
                                      className=""
                                    />
                                    {t('Print')}
                                  </>
                                )}
                              </button>
                            </li>
                          )}
                          {i18n.language === 'en' && (
                            <li className="saveSection updatedSection hide">
                              {isCouponAddedinBasket ? (
                                <button className="button savebtn text-button-padding themeFocus disabled pointerNone dialogComponent">
                                  Saved
                                </button>
                              ) : (
                                <button
                                  onClick={handleSaveCoupon}
                                  className="button text-button-padding savebtn themeFocus dialogComponent"
                                >
                                  Save
                                </button>
                              )}
                            </li>
                          )}
                        </ul>
                      }
                      {item.Prices[0].PBAClientName ===
                        WALMART_PBA_CLIENT_NAME &&
                        !contactSent && (
                          <div className="pharmacy-item__pricing-msg">
                            <p className="item__pricing">
                              {t('WALMART_PHARMACY_DESCRIPTION_2')}
                            </p>
                          </div>
                        )}
                    </div>
                  ) : (
                    <div className="errorCardImgMain">
                      <h4>{t('ErrorHead')}</h4>
                      <p>{t('ErrorPara1')}</p>
                      <p>{t('ErrorPara2')}</p>
                    </div>
                  )}

                  <div
                    className={`actionModal ${
                      showPopOver ? 'showModal' : 'hideModal'
                    } ${contactSent && 'purpleSuccessModal'}
                    ${isEmailFlag && !contactSent ? 'emailInputBox' : ''} 
                    ${
                      sendType === 'text' && !contactSent ? 'textInputBox' : ''
                    }`}
                    aria-modal={
                      contactSent || showContactSentMsg ? true : false
                    }
                  >
                    {showPopOver && (
                      <SendContact
                        isEmail={sendType === 'email'}
                        drugData={drugData}
                        selectedPrice={cheapestPrice}
                        selectedPharmacyName={item.Pharmacy.Name}
                        buttonClicked={isEmailFlag}
                        doNotMarket={doNotMarket}
                        selectedDisplayQuantity={selectedDisplayQuantity}
                        setSignupModal={setSignupModal}
                        contactSent={contactSent}
                        updateContactSent={updateContactSent}
                        eventObj={sendCouponObj}
                        sentMessage={sentMessage}
                      />
                    )}
                  </div>

                  <div>
                    {showPfizer && !isProceedClicked ? (
                      <PfizerModal handlePfizerClick={handlePfizerClose} />
                    ) : (
                      <div className="mobile-only">
                        <div className="couponMainSection">
                          {isContactLoading ? (
                            <div className="loaderContainer">
                              <img
                                src="/content/images/loader/loading.gif"
                                alt={t('Coupon card loading')}
                                className="couponLoader"
                              />
                            </div>
                          ) : (
                            <div className="flexContent">
                              <div
                                className="couponCard"
                                data-bin={hiddenParams.bin}
                                data-pcn={hiddenParams.pcn}
                                data-groupnumber={hiddenParams.grpNumber}
                                data-authnumber={hiddenParams.authNumber}
                                data-pharmacyname={item.Pharmacy.Name}
                                data-logourl={item.Pharmacy.LogoUrl}
                              >
                                {pdfUrl && (
                                  <Image
                                    imageUrl={pdfUrl}
                                    imageAlt={t('discount-card-param', {
                                      pharmacy: _.getPharmacyALTName(
                                        item.Pharmacy.Name
                                      )
                                    })}
                                    imageClass="contactImage"
                                    containerClass="imageContainer"
                                    loaderClass="loaderImage"
                                    loaderalt={t('Coupon card loading')}
                                    role="progressbar"
                                  />
                                )}
                              </div>

                              <ul className="actionButton">
                                {i18n.language === 'en' && (
                                  <li className="saveSection hide">
                                    {isCouponAddedinBasket ? (
                                      <button className="button savebtn text-button-padding themeFocus disabled pointerNone dialogComponent">
                                        Coupon saved
                                      </button>
                                    ) : (
                                      <button
                                        onClick={handleSaveCoupon}
                                        className="button text-button-padding savebtn themeFocus dialogComponent"
                                      >
                                        Save coupon
                                      </button>
                                    )}
                                  </li>
                                )}
                                <li
                                  className={`${
                                    buttonDisabled === 'text' && 'buttonHide'
                                  }`}
                                >
                                  <button
                                    className={`button pink text-send text-button-padding themeFocus dialogComponent `}
                                    id="text"
                                    onClick={toggleTrueFalse}
                                  >
                                    {t('Text')}
                                  </button>
                                </li>
                                <li className="newSendForm">
                                  <div
                                    className={`actionModal actionNewModal ${
                                      showPopOver ? 'showModal' : 'hideModal'
                                    } ${
                                      contactSent &&
                                      !isLoggedIn &&
                                      'purpleSuccessModal'
                                    }`}
                                  >
                                    {showPopOver && (
                                      <SendContact
                                        isEmail={sendType === 'email'}
                                        drugData={drugData}
                                        selectedPrice={cheapestPrice}
                                        selectedPharmacyName={
                                          item.Pharmacy.Name
                                        }
                                        buttonClicked={isEmailFlag}
                                        doNotMarket={doNotMarket}
                                        selectedDisplayQuantity={
                                          selectedDisplayQuantity
                                        }
                                        setSignupModal={setSignupModal}
                                        contactSent={contactSent}
                                        updateContactSent={updateContactSent}
                                        eventObj={sendCouponObj}
                                        sentMessage={sentMessage}
                                      />
                                    )}
                                  </div>
                                </li>
                                <li
                                  className={`${
                                    buttonDisabled === 'email' && 'buttonHide'
                                  }`}
                                >
                                  <button
                                    className={`button pink email-send email-button-padding themeFocus dialogComponent `}
                                    id="email"
                                    onClick={toggleTrueFalse}
                                  >
                                    {t('Email')}
                                  </button>
                                </li>
                                {pdfLoading ? (
                                  <img
                                    src="/content/images/loader/loading.gif"
                                    alt="loader"
                                    className="pdfLoader"
                                  />
                                ) : (
                                  i18n.language === 'en' && (
                                    <li className="desktop-only">
                                      <button
                                        className="button pinkBorderButton print-button print-button-padding themeFocus dialogComponent"
                                        onClick={handlePrintClick}
                                      >
                                        {t('Print')}
                                      </button>
                                    </li>
                                  )
                                )}
                                {i18n.language === 'en' && (
                                  <li className="saveSection updatedSection hide">
                                    {isCouponAddedinBasket ? (
                                      <button className="button savebtn text-button-padding themeFocus disabled pointerNone dialogComponent">
                                        Saved
                                      </button>
                                    ) : (
                                      <button
                                        onClick={handleSaveCoupon}
                                        className="button text-button-padding savebtn themeFocus dialogComponent"
                                      >
                                        Save
                                      </button>
                                    )}
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                          {item.Prices[0].PBAClientName ===
                            WALMART_PBA_CLIENT_NAME &&
                            !contactSent && (
                              <div className="pharmacy-item__pricing-msg">
                                <p className="item__pricing">
                                  {t('WALMART_PHARMACY_DESCRIPTION_2')}
                                </p>
                              </div>
                            )}
                          <div className="textCenter pharmacyNote">
                            {t('Show this free card to your pharmacist')}
                            &nbsp;{t('at')}&nbsp;
                            <span>{item.Pharmacy.Name}</span>.&nbsp;
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="walletAction">
                    {isWalletUrlLoading ? (
                      <div className="loaderContainer wallet">
                        <img
                          src="/content/images/loader/loading.gif"
                          alt={t('Coupon card loading')}
                          className="couponLoader"
                        />
                      </div>
                    ) : (
                      <div
                        className="wallet"
                        onClick={e => addToWalletHandler(e, item)}
                      >
                        {isAndroid ? (
                          <img
                            alt="android wallet"
                            className="android-img"
                            src={
                              i18n.language === 'en'
                                ? '/content/images/prescriptions/android-wallet.svg'
                                : '/content/images/prescriptions/android-wallet-es.svg'
                            }
                          />
                        ) : (
                          <img
                            alt="apple wallet"
                            className="apple-img"
                            src={
                              i18n.language === 'en'
                                ? '/content/images/prescriptions/apple-wallet.svg'
                                : '/content/images/prescriptions/apple-wallet-es.svg'
                            }
                          />
                        )}
                      </div>
                    )}
                  </div>
                  <div className="mobile-only">
                    <PromoSlot
                      iconImg="/content/images/icons/appIconNew.svg"
                      heading={t('Switch to the free app')}
                      linkText={t('Install now')}
                      linkUrl="https://singlecare.onelink.me/OxIQ/c8fe6bf"
                    />
                  </div>
                </div>
              </Dialog>
            </div>
          )
        )}
      </div>
    </>
  );
};

CouponModal.propTypes = {
  item: any,
  drugData: any,
  isProceedClicked: bool,
  handlepFizer: func,
  selectedDisplayQuantity: any,
  doNotMarket: bool,
  position: number,
  couponShowHideInfoFunc: object
};

export default CouponModal;
